const colors = {
  gray: '#9FA2B4',
  lightgray: '#DFE0EB',
  blue: '#003657',
  green: '#29CC97',
};

export default colors;
